var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNothingToDisplayIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7745_4450)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 254,
    height: 254,
    rx: 15,
    fill: "#EEF0FE",
    stroke: "#4A4A68",
    strokeWidth: 2,
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7689 60.9552L90.636 40.1496M104.132 33.6512L129.885 37.9951M172.554 44.925L140.447 40.1496M207.229 70.1091L208.195 95.8619M208.195 102.843L207.229 127.82L195.663 125.803M187.61 124.833L166.94 121.686M157.772 120.304L140.447 117.733M128.569 115.862L111.231 113.23M99.1927 110.23L88.0788 108.543L89.7691 74.9809M183.407 46.0622L205.173 49.7699L206.064 59.2084",
    stroke: "#1CDBCA",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.8291,
    cy: 121.597,
    r: 8.45897,
    fill: "#223BF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7241 119.991C83.1166 119.744 84.5656 118.997 84.8019 117.434",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.179 194.02C118.157 202.357 107.106 230.356 99.174 242.745C98.6908 243.499 97.6123 243.226 97.5614 242.331C96.8466 229.775 102.563 208.423 88.41 209.138C73.2915 209.902 79.1641 240.597 58.1731 224.867C37.1821 209.138 72.7534 211.75 70.2568 200.619C67.7602 189.488 35.3049 213.83 29.0634 204.676C22.8219 195.522 41.5463 194.274 47.7877 181.375C54.0291 168.476 38.0707 168.356 22.2985 177.27C6.55857 186.167 7.62312 157.237 37.0009 158.473C37.1173 158.478 37.2492 158.509 37.3573 158.553C47.0033 162.447 33.2244 146.168 27.02 142.445C20.7786 138.701 7.79187 127.417 25.319 120.625C42.8462 113.833 43.8588 163.602 61.2642 180.158C78.6696 196.715 97.2922 182.982 109.179 194.02Z",
    fill: "#1CDBCA",
    stroke: "#1CDBCA",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0512 128.834C82.6829 142.798 133.038 148.824 142.164 143.103C151.233 137.418 146.441 126.436 145.237 122.673C146.081 122.562 147.814 122.664 147.988 123.969C148.206 125.6 148.315 121.033 149.076 121.251C149.685 121.425 150.345 123.135 150.598 123.969L152.012 121.251L152.991 123.969C153.607 122.809 154.927 120.641 155.275 121.251C155.622 121.86 156 123.317 156.145 123.969C156.725 122.589 158.015 120.112 158.537 121.251C159.189 122.673 166.041 146.155 152.012 156.594C140.152 165.421 105.22 161.484 94.0461 159.662C103.229 161.883 128.964 168.969 152.012 178.338C183.048 190.954 187.657 212.758 187.374 220.244C187.143 226.329 183.891 235.677 182.95 238.677C184.953 239.372 195.851 240.749 195.272 245.218C194.693 249.686 169.062 245.148 161.542 243.759C161.951 233.991 167.353 219.799 155.275 209.916C145.524 201.937 137.593 200.317 134.273 202.616C131.885 204.269 132.84 208.254 134.261 214.183L134.273 214.231C137.419 227.36 133.681 234.802 131.864 238.677C131.425 239.611 137.347 242.594 136.617 246.027C137.271 247.795 129.068 247.069 126.94 247.069C126.368 247.069 114.753 247.273 107.519 247.069C106.982 242.559 111.969 236.707 107.519 220.244C104.346 208.504 88.2564 199.827 71.8102 189.054C55.364 178.281 48.6406 167.449 37.404 141.683C29.3352 123.182 25.2896 90.3891 37.4042 77.9017C48.5176 66.4461 58.4243 64.3946 74.9736 66.1276C82.4928 66.915 90.0956 69.5647 90.586 70.4228C91.0765 71.2808 88.7468 72.7524 89.1147 73.3654C89.4089 73.8559 90.586 73.9627 90.586 74.9594C90.586 75.9561 88.911 75.209 88.911 75.9561C88.911 76.6459 90.8734 76.9538 90.586 77.9021C90.2986 78.8504 88.2564 78.6918 88.2564 78.6918C88.2564 78.6918 90.586 80.356 89.8503 81.09C89.1147 81.8239 86.5398 80.4769 86.5398 80.4769C86.5398 80.4769 88.911 83.3702 87.3647 83.9253C85.8184 84.4804 72.408 74.9594 63.6337 79.8922C45.3691 90.1603 53.4595 112.863 69.0512 128.834Z",
    fill: "#223BF4",
    stroke: "#223BF4",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7844 111.984C64.8348 108.257 72.3368 112.291 71.2324 117.757C68.3226 115.764 67.3669 117.235 65.1045 120.719L65.0594 120.788C62.7645 124.322 54.1031 123.103 55.6478 121.669C60.6459 117.028 56.734 115.71 60.7844 111.984Z",
    fill: "#1CDBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3009 119.024C72.7393 120.885 71.9707 122.567 69.6678 123.777C68.3984 120.028 70.4523 115.676 72.7587 114.77C73.1526 115.471 73.8624 117.163 73.3009 119.024Z",
    fill: "#1CDBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.8 18.8085L139.279 13.9735L153.431 65.3613L149.458 66.1191L122.8 18.8085Z",
    fill: "#909DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.356 11.7242L192.042 18.0854L167.083 66.6405L162.226 65.9034L166.356 11.7242Z",
    fill: "#909DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.761 33.0518L221.66 44.9342L184.268 71.5772L178.183 69.6238L205.761 33.0518Z",
    fill: "#909DF9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7745_4450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNothingToDisplayIllustration);
export default __webpack_public_path__ + "static/media/nothing-to-display-illustration.dfa4832f304cd9e1459d8d4254d47b67.svg";
export { ForwardRef as ReactComponent };